import React from 'react';
import { MailIcon } from 'lucide-react';
import { BRAND, CONTACT_EMAIL, PRODUCT_NAME } from '../data/salesContent';
export function SiteFooter() {
  return <footer className="border-t border-line bg-canvas px-5 py-12" data-id="element-212" data-mp="3racdildve2yv">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left" data-id="element-213" data-mp="3mg84zxoyhmvo">
        <div data-id="element-214" data-mp="3hgddpt19qva3">
          <p className="text-lg font-extrabold tracking-wide text-ink" data-id="element-215" data-mp="3dgutz0l6oq8u">{BRAND}</p>
          <p className="mt-2 text-sm text-muted" data-id="element-216" data-mp="3dervrt9vnqt1">© 2026 {BRAND} · {PRODUCT_NAME} · Todos los derechos reservados.</p>
        </div>
        <div className="md:text-right" data-id="element-217" data-mp="33if0ws2lj6wp">
          <p className="text-sm text-muted" data-id="element-218" data-mp="33jgf35ews9in">¿Tenés alguna consulta sobre el producto?</p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="mt-1 inline-flex items-center gap-2 rounded text-base font-semibold text-accent transition-colors duration-150 hover:text-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/50" data-id="element-219" data-mp="2yknay3lihuv5">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-220" data-mp="15r50wv9rb4ol" />
            {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </footer>;
}